// /DeviceConfigs/helpers/textFonts.js
// Fonts selectable for the SelfCheckIn texts (design feature).
// The values must match the font aliases registered in the RegasusMobile app (MauiProgram.cs).

export const TEXT_FONT_OPTIONS = [
    { value: '', label: 'Default (Open Sans)' },
    { value: 'OpenSansSemibold', label: 'Open Sans Semibold' },
    { value: 'Roboto', label: 'Roboto' },
    { value: 'Lato', label: 'Lato' },
    { value: 'Poppins', label: 'Poppins' },
    { value: 'Montserrat', label: 'Montserrat' },
    { value: 'Inter', label: 'Inter' },
    { value: 'Oswald', label: 'Oswald' },
    { value: 'Raleway', label: 'Raleway' },
    { value: 'Nunito', label: 'Nunito' },
    { value: 'WorkSans', label: 'Work Sans' },
    { value: 'Rubik', label: 'Rubik' },
    { value: 'Quicksand', label: 'Quicksand' },
    { value: 'Comfortaa', label: 'Comfortaa' },
    { value: 'Manrope', label: 'Manrope' },
    { value: 'DMSans', label: 'DM Sans' },
    { value: 'Barlow', label: 'Barlow' },
    { value: 'Karla', label: 'Karla' },
    { value: 'Jost', label: 'Jost' },
    { value: 'Outfit', label: 'Outfit' },
    { value: 'JosefinSans', label: 'Josefin Sans' },
    { value: 'PlayfairDisplay', label: 'Playfair Display' },
    { value: 'Lora', label: 'Lora' },
    { value: 'EBGaramond', label: 'EB Garamond' },
    { value: 'RobotoSlab', label: 'Roboto Slab' },
    { value: 'Bitter', label: 'Bitter' },
    { value: 'Cormorant', label: 'Cormorant' },
    { value: 'BebasNeue', label: 'Bebas Neue' },
    { value: 'Anton', label: 'Anton' },
    { value: 'Righteous', label: 'Righteous' },
    { value: 'Fredoka', label: 'Fredoka' },
    { value: 'Baloo2', label: 'Baloo 2' },
    { value: 'AbrilFatface', label: 'Abril Fatface' },
    { value: 'Lobster', label: 'Lobster' },
    { value: 'Pacifico', label: 'Pacifico' },
    { value: 'DancingScript', label: 'Dancing Script' },
    { value: 'Caveat', label: 'Caveat' },
    { value: 'AmaticSC', label: 'Amatic SC' },
    { value: 'GreatVibes', label: 'Great Vibes' },
];

// CSS font-family stacks used to approximate the app fonts in the browser preview.
// The web fonts themselves are loaded via Google Fonts in public/index.html.
const FONT_FAMILY_CSS = {
    '': "'Open Sans', sans-serif",
    OpenSansRegular: "'Open Sans', sans-serif",
    OpenSansSemibold: "'Open Sans', sans-serif",
    Roboto: "'Roboto', sans-serif",
    Lato: "'Lato', sans-serif",
    Poppins: "'Poppins', sans-serif",
    Montserrat: "'Montserrat', sans-serif",
    Inter: "'Inter', sans-serif",
    Oswald: "'Oswald', sans-serif",
    Raleway: "'Raleway', sans-serif",
    Nunito: "'Nunito', sans-serif",
    WorkSans: "'Work Sans', sans-serif",
    Rubik: "'Rubik', sans-serif",
    Quicksand: "'Quicksand', sans-serif",
    Comfortaa: "'Comfortaa', sans-serif",
    Manrope: "'Manrope', sans-serif",
    DMSans: "'DM Sans', sans-serif",
    Barlow: "'Barlow', sans-serif",
    Karla: "'Karla', sans-serif",
    Jost: "'Jost', sans-serif",
    Outfit: "'Outfit', sans-serif",
    JosefinSans: "'Josefin Sans', sans-serif",
    PlayfairDisplay: "'Playfair Display', serif",
    Lora: "'Lora', serif",
    EBGaramond: "'EB Garamond', serif",
    RobotoSlab: "'Roboto Slab', serif",
    Bitter: "'Bitter', serif",
    Cormorant: "'Cormorant', serif",
    BebasNeue: "'Bebas Neue', sans-serif",
    Anton: "'Anton', sans-serif",
    Righteous: "'Righteous', sans-serif",
    Fredoka: "'Fredoka', sans-serif",
    Baloo2: "'Baloo 2', sans-serif",
    AbrilFatface: "'Abril Fatface', serif",
    Lobster: "'Lobster', cursive",
    Pacifico: "'Pacifico', cursive",
    DancingScript: "'Dancing Script', cursive",
    Caveat: "'Caveat', cursive",
    AmaticSC: "'Amatic SC', cursive",
    GreatVibes: "'Great Vibes', cursive",
};

export const fontFamilyToCss = (fontFamily) =>
    FONT_FAMILY_CSS[fontFamily] || FONT_FAMILY_CSS[''];
